import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SellerPortalMaterialModule } from './modules/material.modules';
import { SellerPortalCurrencyPipe } from './config/seller-portal-currency.pipe';
import { SellerPortalOrderIDPipe } from './config/seller-portal-order-id.pipe';
import {OnlyNumberDirective,OnlyAlphaNumberSpecialCharacterDirective} from './components/only-number/only-number.directive';
import { OnlyAlphaNumberDirective } from './components/only-number/only-number.directive';
import { AdvancePaymentComponent } from './components/advance-payment/advance-payment.component';
import { SubmitDialogComponent } from './components/submit-dialog/submit-dialog.component';
import { NumberDirective } from './components/number/number.directive';
import { CommonRateCardComponent } from './components/common-rate-card/common-rate-card.component';
import { NumberDecimalDirective } from './components/number-decimal.directive';
import { InvoiceNumberDirective } from './components/invoice-number/invoice-number.directive';
import { DecimalNumberDirective } from './components/decimal-number/decimal-number.directive';
import { TitleCasePipe } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { DndDirective } from './directives/dnd.directive';
import { MatInputAutofocusDirective } from './directives/mat-input-autofocus.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ThousandSuffixesPipe } from './config/thousands-suffix.pipe';
import { SearchPipe } from './config/search.pipe';
import { PaginationComponent } from './components/pagination/pagination.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MultiHandlerRangeSliderDirective } from './directives/multi-handler-range-slider.directive';
import { LightboxZoomComponent } from './components/lightbox-zoom/lightbox-zoom.component';
import { ValidatedInvoiceNumberDirective } from './components/invoice-number/validated-invoice-number.directive';
import { VariantModalComponent } from './components/variant-modal/variant-modal.component';
import { MultiselectDropdownChipsComponent } from './components/multiselect-dropdown-chips/multiselect-dropdown-chips.component';
import { VariantGridTableComponent } from './components/variant-grid-table/variant-grid-table.component';
import { VariantDeleteAlertComponent } from './components/variant-delete-alert/variant-delete-alert.component';
import { NumbersonlyDirective } from './directives/numbersonly.directive';
import { CustomNumberInputComponent } from './components/custom-number-input/custom-number-input.component';
import { EditQuantityDialogComponent } from './modals/edit-quantity-dialog/edit-quantity-dialog.component';
import { CopyImagesDialogComponent } from './modals/copy-images-dialog/copy-images-dialog.component';
import { VariantImagesDeleteAlertComponent } from './components/variant-images-delete-alert/variant-images-delete-alert.component';
import { VariantSizeChartDeleteAlertComponent } from './components/variant-size-chart-delete-alert/variant-size-chart-delete-alert.component';
import { VariantUpdateAlertComponent } from './components/variant-update-alert/variant-update-alert.component';
import { UploadImagesDialogComponent } from '@app/sets/modals/upload-images-dialog/upload-images-dialog.component';
import { PayoutsExportMessageComponent } from './modals/payouts-export-message/payouts-export-message.component';
import { PayoutsExportModalComponent } from './modals/payouts-export-modal/payouts-export-modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        SellerPortalMaterialModule,
        PdfViewerModule,
        InfiniteScrollModule,
        NgxDaterangepickerMd.forRoot(),
    ],
    declarations: [
        SellerPortalCurrencyPipe,
        OnlyNumberDirective,
        OnlyAlphaNumberDirective,
        OnlyAlphaNumberSpecialCharacterDirective,
        SellerPortalOrderIDPipe,
        AdvancePaymentComponent,
        SubmitDialogComponent,
        NumberDirective,
        NumberDecimalDirective,
        InvoiceNumberDirective,
        CommonRateCardComponent,
        DecimalNumberDirective,
        PageNotFoundComponent,
        DndDirective,
        MatInputAutofocusDirective,
        ThousandSuffixesPipe,
        SearchPipe,
        PaginationComponent,
        MultiHandlerRangeSliderDirective,
        LightboxZoomComponent,
        VariantModalComponent,
        MultiselectDropdownChipsComponent,
        VariantGridTableComponent,
        VariantDeleteAlertComponent,
        NumbersonlyDirective,
        CustomNumberInputComponent,
        EditQuantityDialogComponent,
        CopyImagesDialogComponent,
        UploadImagesDialogComponent,
        VariantImagesDeleteAlertComponent,
        VariantSizeChartDeleteAlertComponent,
        VariantUpdateAlertComponent,
        ValidatedInvoiceNumberDirective,
        PayoutsExportMessageComponent,
        PayoutsExportModalComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        SellerPortalMaterialModule,
        SellerPortalCurrencyPipe,
        SellerPortalOrderIDPipe,
        OnlyNumberDirective,
        OnlyAlphaNumberDirective,
        OnlyAlphaNumberSpecialCharacterDirective,
        NumberDirective,
        NumberDecimalDirective,
        InvoiceNumberDirective,
        CommonRateCardComponent,
        DecimalNumberDirective,
        DndDirective,
        MatInputAutofocusDirective,
        PdfViewerModule,
        InfiniteScrollModule,
        ThousandSuffixesPipe,
        SearchPipe,
        PaginationComponent,
        MultiHandlerRangeSliderDirective,
        LightboxZoomComponent,
        VariantModalComponent,
        MultiselectDropdownChipsComponent,
        VariantGridTableComponent,
        VariantDeleteAlertComponent,
        CustomNumberInputComponent,
        VariantImagesDeleteAlertComponent,
        VariantSizeChartDeleteAlertComponent,
        VariantUpdateAlertComponent,
        ValidatedInvoiceNumberDirective,
    ],
    providers: [TitleCasePipe],
})
export class SharedModule {}
